export const impactReportPhaseMap = {
    loading: "loading",
    loadError: "loadError",
    ready: "ready",
    enrolling: "enrolling",
    success: "success",
    enrollError: "enrollError",
} as const;

export type ImpactReportPhase = (typeof impactReportPhaseMap)[keyof typeof impactReportPhaseMap];
